import React from 'react';
import Switch from '@mui/material/Switch';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Brightness1Icon from '@mui/icons-material/Brightness1';

interface MySwitchProps {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  isPublic?: boolean;
}

const CustomerSwitch = (props: MySwitchProps) => {
  const {
    value: checked = false,
    onChange,
    disabled = false,
    isPublic = false,
  } = props;
  return (
    <Switch
      icon={
        <Brightness1Icon
          sx={{ color: disabled ? 'rgba(28, 27, 31, 0.38)' : '#000000' }}
        />
      }
      checkedIcon={
        <CheckCircleIcon sx={{ color: disabled ? '#fffbfe' : '#ffffff' }} />
      }
      onChange={(e, value) => onChange(value)}
      checked={checked}
      disabled={disabled}
      className={`${
        isPublic
          ? '!p-0 [&_.MuiButtonBase-root]:p-1 [&_.MuiSvgIcon-root]:w-5 [&_.MuiSvgIcon-root]:h-5 !w-13 !h-8'
          : '!p-0 !h-6 !w-11 [&_.MuiButtonBase-root]:p-0.5 [&_.MuiSvgIcon-root]:w-4 [&_.MuiSvgIcon-root]:h-4 tablet:[&_.MuiButtonBase-root]:p-1 tablet:[&_.MuiSvgIcon-root]:w-5 tablet:[&_.MuiSvgIcon-root]:h-5 tablet:!w-13 tablet:!h-8'
      }`}
      sx={{
        lineHeight: 52,
        marginRight: 1,
        background: checked
          ? disabled
            ? '#e9e8e9'
            : '#0050b3'
          : disabled
            ? 'rgba(231, 224, 236, 0.12)'
            : '#e2e8f0',
        border: checked
          ? disabled
            ? '2px solid transparent'
            : '2px solid #0050b3'
          : disabled
            ? '2px solid rgba(28, 27, 31, 0.12)'
            : '2px solid #334155',
        borderRadius: 35,
        ':hover': {
          background: disabled ? '' : checked ? '#0050b3' : '#e2e8f0',
        },
        '.MuiSwitch-track': {
          height: 0,
          width: 0,
        },
      }}
    />
  );
};
export default CustomerSwitch;
